var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.8087 5.10962C16.0625 4.85578 16.0625 4.44422 15.8087 4.19038C15.5548 3.93654 15.1433 3.93654 14.8894 4.19038L9.99952 9.08029L5.10962 4.19038C4.85578 3.93654 4.44422 3.93654 4.19038 4.19038C3.93654 4.44422 3.93654 4.85578 4.19038 5.10962L9.08029 9.99952L4.19038 14.8894C3.93654 15.1433 3.93654 15.5548 4.19038 15.8087C4.44422 16.0625 4.85578 16.0625 5.10962 15.8087L9.99952 10.9188L14.8894 15.8087C15.1433 16.0625 15.5548 16.0625 15.8087 15.8087C16.0625 15.5548 16.0625 15.1433 15.8087 14.8894L10.9188 9.99952L15.8087 5.10962Z"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"currentColor"};

module.exports = Close;

Close.default = Close;
